// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"f37fddf5","59":"e343d5d2","85":"961b3cfd","238":"edd5fd00","266":"152b0bc6","337":"336ba96d","363":"c842894d","379":"401fbe7e","386":"424994b7","389":"2d00de16","488":"ffee1f91","612":"27c7da4d","675":"cdf55fa3","714":"31addc46","752":"6f245af2","886":"7fffdf4e"}[chunkId] + ".chunk.js";
};